const LEGACY_DEFAULT_TERMS_AND_CONDITIONS = 'Standard terms apply.';
const DEFAULT_BOOKING_POLICY_TITLE = 'Terms and Conditions of Service – K2 Occupational Health';
const DEFAULT_BOOKING_POLICY_URL = 'https://www.k2occupationalhealth.com/terms-conditions/';
const URL_PATTERN = /https?:\/\/[^\s]+/i;
const FULL_URL_PATTERN = /^https?:\/\/[^\s]+$/i;

export function getBookingPolicyLink(termsAndConditions: string) {
  const normalized = termsAndConditions.trim();
  if (!normalized || normalized === LEGACY_DEFAULT_TERMS_AND_CONDITIONS) {
    return { title: DEFAULT_BOOKING_POLICY_TITLE, url: DEFAULT_BOOKING_POLICY_URL };
  }
  const lines = normalized
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);
  const title =
    lines.find((l) => !FULL_URL_PATTERN.test(l) && !URL_PATTERN.test(l)) ||
    DEFAULT_BOOKING_POLICY_TITLE;
  const url =
    lines.find((l) => FULL_URL_PATTERN.test(l)) ||
    normalized.match(URL_PATTERN)?.[0] ||
    DEFAULT_BOOKING_POLICY_URL;
  return { title, url };
}

function deg2rad(deg: number) {
  return deg * (Math.PI / 180);
}

export function getDistanceFromLatLonInMiles(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 3958.8;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
